import React, { useMemo } from 'react';

import './styles.scss';
import PropTypes from 'prop-types';
import Icon, { ClockIcon } from 'components/Atoms/Icon';
import moment from 'moment';

const TimeLeft = ({ time }) => {
  const dayLeft = useMemo(() => moment(time).diff(moment(), 'days'), [time]);
  const _getText = useMemo(
    () =>
      dayLeft >= 0
        ? `${dayLeft || 1} ${dayLeft > 1 ? 'days' : 'day'} left`
        : 'Expired',
    [dayLeft]
  );

  const _getStatus = useMemo(() => {
    if (dayLeft < 5) return 'my-time-status-danger';
    if (dayLeft <= 10) return 'my-time-status-warning';
    return 'my-time-status-good';
  }, [dayLeft]);
  return (
    <div className="d-inline-block">
      <div id="my-time-left" className={_getStatus}>
        <Icon component={ClockIcon} className="my-time-icon" />
        <span className="my-time-text">{_getText}</span>
      </div>
    </div>
  );
};

export default TimeLeft;

TimeLeft.propTypes = {
  time: PropTypes.string,
};
